import { BoxProps, makeStyledComponent } from '@apia/theme';
import { Children, ReactElement, ReactNode } from 'react';
import { SortableListContext } from './SortableListHandler';
import { SortableListItem, TSortableListItem } from './SortableListItem';

export const UnstyledSortableList = ({
  boxProps,
  children,
  onSortChange,
}: {
  boxProps?: BoxProps;
  children: ReactNode;
  onSortChange?: (items: ReactElement<TSortableListItem>[]) => unknown;
}) => {
  Children.forEach(children, (el) => {
    if ((el as ReactElement<TSortableListItem>)?.type !== SortableListItem)
      throw new Error(
        `Every children of a SortableList must be of type SortableListItem`,
      );
  });

  return (
    <SortableListContext onSortChange={onSortChange} boxProps={boxProps}>
      {children}
    </SortableListContext>
  );
};

export const SortableList = makeStyledComponent(
  'SortableList',
  'layout.common.components.sortableList',
  {
    '.sortableList': { display: 'flex', flexDirection: 'column' },
    '.sortableList__item': {
      cursor: 'pointer',
    },
    '.dragging': {
      opacity: '0.3',
    },
    '.dragover': { position: 'relative' },
    '.dragover:after': {
      display: 'block',
      content: '""',
      position: 'absolute',
      height: '4px',
      left: '0',
      top: '-4px',
      bottom: 'auto',
      width: '100%',
      backgroundColor: 'palette.primary.main',
      zIndex: 9,
    },
    '.dragover.after:after': {
      top: 'auto',
      bottom: '-4px',
    },
  },
  UnstyledSortableList,
);

export { SortableListItem };
